import { render, staticRenderFns } from "./EditProductModal.vue?vue&type=template&id=6bc90f9c"
import script from "./EditProductModal.vue?vue&type=script&lang=js"
export * from "./EditProductModal.vue?vue&type=script&lang=js"
import style0 from "./EditProductModal.vue?vue&type=style&index=0&id=6bc90f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports